export const isRemovedContent = (status?: string) => status === 'deleted' || status === 'refused';
